import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "buttons" }
const _hoisted_2 = ["disabled"]

import { ServiceTeamItem } from '@/services/entities/ServiceTeams/ServiceTeamItem';
import TeamPropertiesForm from '@/components/service_teams/forms/TeamPropertisForm.vue';
import { VueFinalModal } from 'vue-final-modal';
import TileCard from '@/components/util/TileCard.vue';
import { onMounted } from 'vue';
import { useSettingsStore } from '@/stores/setting';


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateTeamModal',
  props: {
    team: {Type: {} as ServiceTeamItem, default: {} as ServiceTeamItem},    
},
  emits: ["close", "create"],
  setup(__props, { emit: __emit }) {

const settingsStore = useSettingsStore();
const emit = __emit;
const props = __props;


onMounted(async () => {
    await settingsStore.loadServices();
});


function clearSelection() {

}


function canCreate() {
    return (props.team.teamName != null && props.team.teamName.length > 0)
        && ((props.team.service != null && props.team.service.id != null));
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueFinalModal), {
    class: "modal",
    "content-class": "modal-content",
    "overlay-transition": "vfm-fade",
    clickToClose: false,
    onOpened: clearSelection,
    onClickOutside: _cache[2] || (_cache[2] = ($event: any) => (emit('close')))
  }, {
    default: _withCtx(() => [
      _createVNode(TileCard, {
        loaded: _unref(settingsStore).getServicesLoaded,
        class: "tile-card"
      }, {
        body: _withCtx(() => [
          _createVNode(TeamPropertiesForm, {
            team: props.team
          }, null, 8, ["team"])
        ]),
        _: 1
      }, 8, ["loaded"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          class: "accent",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
        }, "Cancel"),
        _createElementVNode("button", {
          class: "accent",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('create'))),
          disabled: !canCreate()
        }, "Create", 8, _hoisted_2)
      ])
    ]),
    _: 1
  }))
}
}

})